<template>
  <div class="headerBar">
    <!-- 左侧 -->
    <div class="logo_box">
      <p class="logo">Neuedu</p>
      <p class="logo_text">个体销售管理系统</p>
    </div>
    <!-- 右侧 -->
    <div class="logout_box">
      <div>
        <font-awesome-icon :icon="['fas', 'user']" />
        <span v-if="navList">{{navList}}</span>
      </div>
      <div @click="logOut">
        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
        <span>注销</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      // 正式环境
    }
  },
  methods: {
    logOut: function () {
      this.$axios
        .post(this.$api.logout)
        .then(res => {
          if (res.data.flag === 'successeed') {
            // 正式环境
            window.location.href = res.data.redirectUrl
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  computed: {
    navList () {
      return this.$store.state.staffName
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/HeaderBar.vue